// import external dependencies
import 'jquery';
import 'jquery-confirm';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Vue
import Vue from 'vue'
import vSelect from 'vue-select'
import VTooltip from 'v-tooltip'
Vue.component('v-select', vSelect)
Vue.use(VTooltip)

// import local dependencies
import Router from './util/Router';
import sessies from './routes/sessies';
import agenda from './routes/agenda';
import mijnAccount from './routes/mijnAccount';
import profiel from './routes/profiel';
import boekingen from './routes/boekingen';

/** Populate Router instance with DOM routes */
const routes = new Router({
    sessies,
    agenda,
    mijnAccount,
    profiel,
    boekingen,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(document).ready(function () {
    function tafelgasten_log_remove()
    {
        // let log_item = $('.expert_notification-message');
        $('body').on('click', '[data-close]', function (e) {
          console.log(e);
          console.log($(this));
            $(this).parents('.expert_notification-message').remove();
        })
    }

  // eslint-disable-next-line no-unused-vars
    function tafelgasten_create_log(title, message, timeout = 3000)
    {
        let log_template = $('.expert_notification-message-template');
        let clone = log_template.clone();
        clone.find('[data-log-title]').html(title);
        clone.find('[data-log-txt]').html(message);
        clone.attr('style', '--timeout: ' + timeout + 'ms');
        clone.removeClass('expert_notification-message-template');
        log_template.after(clone);
        setTimeout(function () {
            clone.addClass('log-appear');
        }, 1);

        setTimeout(function () {
            clone.removeClass('log-appear');
            setTimeout(function () {
                clone.remove();
            }, 1000);
        }, timeout);
    }

    tafelgasten_log_remove();
    // tafelgasten_create_log('Fout', 'Je bent niet ingelogd!', 20000);
});



// WEBPACK FOOTER //
// ./scripts/main.js